import React from "react";

export const SortDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_2370_7249)">
      <path
        d="M16 0.666667C16 1.03533 15.7013 1.33333 15.3333 1.33333H6.66667C6.29867 1.33333 6 1.03533 6 0.666667C6 0.298 6.29867 0 6.66667 0H15.3333C15.7013 0 16 0.298 16 0.666667ZM13.3333 3.33333H6.66667C6.29867 3.33333 6 3.63133 6 4C6 4.36867 6.29867 4.66667 6.66667 4.66667H13.3333C13.7013 4.66667 14 4.36867 14 4C14 3.63133 13.7013 3.33333 13.3333 3.33333ZM11.3333 6.66667H6.66667C6.29867 6.66667 6 6.96467 6 7.33333C6 7.702 6.29867 8 6.66667 8H11.3333C11.7013 8 12 7.702 12 7.33333C12 6.96467 11.7013 6.66667 11.3333 6.66667ZM9.33333 10H6.66667C6.29867 10 6 10.298 6 10.6667C6 11.0353 6.29867 11.3333 6.66667 11.3333H9.33333C9.70133 11.3333 10 11.0353 10 10.6667C10 10.298 9.70133 10 9.33333 10ZM5.138 12.862L4 14V0.666667C4 0.298 3.70133 0 3.33333 0C2.96533 0 2.66667 0.298 2.66667 0.666667V14L1.528 12.8613C1.26733 12.6007 0.845998 12.6007 0.585332 12.8613C0.324665 13.122 0.324665 13.5433 0.585332 13.804L2.39 15.6087C2.65 15.8687 2.99133 15.9987 3.33333 15.9987C3.67533 15.9987 4.016 15.8687 4.276 15.6087L6.08067 13.804C6.34133 13.5433 6.34133 13.122 6.08067 12.8613C5.82 12.6007 5.39866 12.6013 5.138 12.862Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2370_7249">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
